<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-02-26 17:07:08
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="page_title">{{$t('privagypolicy.title')}}</div>
    <div id="TermsOfUse"></div>
  </div>
</template>

<script>
import { getPrivagypolicy } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
    getPrivagypolicy(this.key).then((adj) => {
      this.msg = adj.data
      document.getElementById('TermsOfUse').innerHTML = this.msg
      console.log(this.msg)
    })
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  background: #fff;
  min-height: 100%;
  position: absolute;
  overflow: hidden;
}
#TermsOfUse {
  width: 85%;
  max-width: 800px;
  margin-left: 5%;
  font-size: 14px;
  color: #3f3f3f;
  line-height: 20px;
  font-family: Noto Sans;
}
</style>



// WEBPACK FOOTER //
// src/components/Privagypolicy.vue